<script lang="ts">
  import { parseUrl } from "$lib/utils/helpers";
  import type { Link } from "$types/data";

  export let href: string | Link | null = null;
  export let transparent: boolean = false;
  export const target: "_blank" | null = null;
  export let noText = false;
  export let iconClasses: string = "";
  export let labelElement: string = "";

  const as = href ? "a" : "button";
  const extra = href ? { href: parseUrl(href) } : {};
</script>

<svelte:element
  this={as}
  class={`arrow-link group ${transparent ? "!bg-transparent" : ""} ${
    $$restProps.class || ""
  } `}
  {...extra}
  aria-labelledby={labelElement}
>
  <span
    class={`icon-wrapper ${
      $$restProps?.class?.includes("hover-red-bg")
        ? "group-hover:!text-white group-hover:!bg-[rgb(var(--color-red-secondary))]"
        : ""
    }`}
  >
    <span class={iconClasses}>
      <svg width="16" height="16"
        ><use xlink:href="/svg/icons.svg#arrow-right" /></svg
      >
    </span>
    <!-- <span class="{iconClasses} hover-arrow group-hover:!opacity-100 group-hover:!translate-x-[0]">
			<svg width="16" height="16"><use xlink:href="/svg/icons.svg#arrow-right" /></svg>
		</span> -->
  </span>

  {#if noText !== true}<div class="button-label">
      <span class="type:section-title"><slot /></span>
    </div>{/if}
</svelte:element>

<style lang="scss">
  .arrow-link {
    @apply flex items-center cursor-pointer appearance-none no-underline font-normal p-0 bg-transparent;
    color: rgb(var(--color-text-dark));
    border: none;

    &.white-arrow {
      .icon-wrapper {
        @apply bg-white text-black;
      }
    }

    .icon-wrapper {
      padding: 0 fluid(16px, 16px);
      height: fluid(54px, 54px);
      min-width: fluid(72px, 72px);
      @apply flex justify-center items-center relative;
      line-height: 1;
      border-radius: var(--border-radius-small);
      border: none;
      color: rgb(var(--color-white));
      width: max-content;
      transition: background 0.3s;
      background: rgb(var(--color-text-dark));

      .initial-arrow {
        display: inline-block;
        transition:
          color 0.3s ease-in-out,
          transform 0.3s ease-in-out,
          opacity 0.2s 0.1s;
      }

      .hover-arrow {
        @apply absolute inset-0 flex items-center justify-center opacity-0;
        transform: translateX(-30px);
        transition:
          color 0.3s ease-in-out,
          transform 0.3s ease-in-out,
          opacity 0.2s 0.1s;
      }
    }

    .button-label {
      padding-left: 16px;
    }

    &:hover {
      .hover-arrow {
        opacity: 1;
        transform: translateX(0);
      }

      .initial-arrow {
        opacity: 0;
        transform: translateX(30px);
      }
    }

    &.hover-red-bg {
      &:hover {
        .icon-wrapper {
          color: rgb(var(--color-white));
          background: rgb(var(--color-red-secondary));
        }
      }
    }

    &.reduced {
      .icon-wrapper {
        height: 36px;
        padding: 0 16px;
        min-width: 56px;
      }
    }
    &.bg-grey {
      .icon-wrapper {
        background: #dfdedc;
        color: rgb(var(--color-text-dark));
      }
    }
    &.sentence-case {
      .button-label {
        .type\:section-title {
          text-transform: none;
        }
      }
    }
  }
</style>
